import { CommonModule } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { AfterViewInit, Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import {
  DealerDto,
  DealerLoggerDto,
  DealerMenuItemDto,
  DealerTableDto,
  UpdateDealerTableDto,
} from '@core/dtos'
import { DealerHttp, GameHttp } from '@core/https'
import { AccountService } from '@core/services'
import { environment } from '@src/environments/environment'
import { MenuCardV2Component } from '../menu/menu-card-v2/menu-card-v2.component'

@Component({
  selector: 'app-game-panel-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, MenuCardV2Component],
  providers: [DealerHttp],
  templateUrl: './game-panel-menu.component.html',
  styleUrl: './game-panel-menu.component.sass',
})
export class GamePanelMenuComponent implements OnInit, AfterViewInit {
  constructor(
    private _dealerHttp: DealerHttp,
    private _gameHttp: GameHttp,
    private _accountService: AccountService,
    private _router: Router,
  ) {}

  dealers: DealerMenuItemDto[] = []
  private readonly loggerId = this._accountService.currentUserId

  ngOnInit(): void {
    this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
      this.dealers = i.dealerMenuItems.filter((dealer) => {
        if (!dealer.dealerLogger) {
          return true
        }

        return dealer.dealerLogger.hasLogger !== true
      })
    })
  }

  trackByDealer(index: number, dealer: DealerMenuItemDto) {
    return dealer.id
  }

  ngAfterViewInit() {
    this._dealerHttp.getDealerLogger(this.loggerId).subscribe((dealerLogger) => {
      if (dealerLogger) {
        this._router.navigate([`logger/${dealerLogger.dealerId}`])
      }
    })
  }

  async updateDealerTable(dealerId: string) {
    const data = {
      hasLogger: true,
      loggerId: this.loggerId,
      dealerId,
    } as DealerLoggerDto

    await this._dealerHttp.updateDealerLogger(data)
    this._router.navigate(['logger', dealerId])
  }
}
